// A singlePage is the render of a page from Wordpress.

import React, { useState, useEffect, Fragment, lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { removeUnicode } from "../utils/utilityFunctions";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const SinglePage = lazy(() =>
  import(/* webpackChunkName: "SinglePage" */ "../components/Page/SinglePage")
);
const PageNotFound = lazy(() =>
  import(/* webpackChunkName: "PageNotFound" */ "./pageNotFound")
);

import { makeStyles } from 'tss-react/mui';
import { CircularProgress } from "@mui/material";

// Redux stuff
import { connect } from "react-redux";

let useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
  progressDiv: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
}));

function singlePage(props) {
  const { classes } = useStyles();
  const history = useHistory();

  const [pageData, setPageData] = useState(getPageDataFromStaticContext());
  const [isLoading, setIsLoading] = useState(true);
  const [isNotFound, setIsNotFound] = useState(false);

  function getPageDataFromStaticContext() {
    const pageData = props.staticContext ? props.staticContext : null;
    return pageData;
  }

  useEffect(() => {
    // If we didnt get pageData from SSR, load from location state.
    let timer = setTimeout(() => {
      if (global.window.__ROUTE_DATA__) {
        const data = global.window.__ROUTE_DATA__;
        setPageData(data);
        setIsLoading(false);
        setIsNotFound(false);
        delete global.window.__ROUTE_DATA__;
      } else {
        //If pageData is undefined, then we are on the client side and need to fetch the data
        if (!pageData) {
          let slug = window.location.pathname
            .split("/page/")[1]
            .replace(/\/$/, ""); // This removes the trailing slash

          setIsLoading(true);

          axios
            .get(`/api/pages/getPage/${slug}`)
            .then((res) => {
              setPageData(res.data);
              setIsLoading(false);
              setIsNotFound(false);
            })
            .catch((err) => {
              console.error("Unable to get single page data: ", err);
              setIsLoading(false);
              setIsNotFound(true);
            });
        } else {
          console.log("DATA ALREADY FETCHED");
          setIsLoading(false);
        }
      }
    }, 0);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={classes.fullPageHeight}>
      {pageData ? (
        <CustomMeta
          title={removeUnicode(pageData.title)}
          description={removeUnicode(pageData.description)}
          ogImage={pageData.ogImage}
          url={pageData.url}
        />
      ) : null}
      {isLoading ? (
        <div className={classes.progressDiv}>
          <CircularProgress size={25} />
        </div>
      ) : isNotFound ? (
        <Suspense fallback={<div />}>
          <PageNotFound />
        </Suspense>
      ) : (
        <Fragment>
          {ExecutionEnvironment.canUseDOM && (
            <Suspense fallback={<div />}>
              <SinglePage pageData={pageData} />
            </Suspense>
          )}
        </Fragment>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
});

export default connect(mapStateToProps)(singlePage);
